import SigliveServiceV2 from 'Service/sigliveServiceV2';

const getNotification = async (queries) => {
  const { data } = await SigliveServiceV2({ method: 'GET', url: `/notification?${queries}` });

  return data?.data;
};

export default getNotification;
